import DataBlock from './DataBlock'

export default DataBlock
